// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductMainInfoList_container__uFBsH","title":"ProductMainInfoList_title__1Krjo","value":"ProductMainInfoList_value__25_QB"};